export function BungieError (response) {
  this.name = 'BungieApiError'
  this.response = response
}

BungieError.prototype = Error.prototype



// WEBPACK FOOTER //
// ./src/utils/exceptions.js